import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import isString from 'lodash/isString';

import { useHandleGenerator } from '../../contexts/RoutesContext';
import { useMenuOpen, useToggleMenu, useCloseMenu } from '../../contexts/MenusContext';
import { useSetUser } from '../../contexts/AuthContext';

import Link from './Link';
import Burger from '../buttons/Burger';
import MainMenu from '../menus/Main';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/header.module.scss';

const propTypes = {
    user: PropTypes.string,
    menu: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string,
};

const defaultProps = {
    user: null,
    menu: [],
    className: null,
};

const Header = ({ user, menu, className }) => {
    const handle = useHandleGenerator();
    const menuOpen = useMenuOpen();
    const toggleMenu = useToggleMenu();
    const closeMenu = useCloseMenu();
    const setUser = useSetUser();

    const onClickCountry = useCallback(() => {
        setUser(null);
    }, [setUser]);

    const onClickDonate = useCallback(() => {
        closeMenu();
    }, [closeMenu]);

    return (
        <header
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <MainMenu className={styles.main} items={menu} />
                {user && isString(user) ? (
                    <div className={styles.left}>
                        {user === 'CA' ? (
                            <span className={styles.button}>
                                <Link
                                    className={styles.link}
                                    href={handle('email')}
                                    onClick={onClickDonate}
                                >
                                    <FormattedMessage
                                        id="content.buttons.donate"
                                        defaultMessage="Faire un don"
                                        description="Button"
                                    />
                                </Link>
                            </span>
                        ) : null}
                        <span className={classNames([styles.button, styles.hidden])}>
                            <button
                                type="button"
                                className={styles.logout}
                                onClick={onClickCountry}
                            >
                                ({user})
                            </button>
                        </span>
                    </div>
                ) : null}
                <div className={styles.menu}>
                    <Burger className={styles.burger} onClick={toggleMenu} isActive={menuOpen} />
                </div>
            </div>
        </header>
    );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
